import React from 'react';

export const authRouteConfig = [
  {
    path: '/laju/ui/',
    component: React.lazy(() => import('./Signin')),
  },
  {
    path: '/laju/ui/signin',
    component: React.lazy(() => import('./Signin')),
  },
  {
    path: './forget-password',
    component: React.lazy(() => import('./ForgotPassword')),
  },
];
